import React from "react";

import Context from "../../../context/Context";

const CSS = {
  main: "i-about",
  product: "i-product",
  productLogo: "i-product-logo",
  productInfo: "i-product-info",
  productName: "i-product-name",
  productVersion: "i-product-version"
};

export default class About extends React.Component {

  render() {
    return (
      <div className={CSS.main}>
        {this.renderProduct()}
      </div>
    );
  }

  renderProduct() {
    const i18n = Context.getInstance().i18n;
    const vinfo = Context.getInstance().versionInfo;
    let version = vinfo.version;
    if (typeof vinfo.build === "string" && vinfo.build.trim().length > 0) {
      version = vinfo.build.trim();
    }
    const vtext = i18n.about.versionPattern.replace("{version}",version);
    return (
      <div className={CSS.product}>
        <div className={CSS.productLogo}></div>
        <div className={CSS.productInfo}>
          <div className={CSS.productName}>ArcGIS Indoors</div>
          <div className={CSS.productVersion}>{vtext}</div>
        </div>
      </div>
    );
  }

}
